import { Grid, Typography } from "@mui/material";
import styled from "styled-components";

import WorldMapImage from "../../../../../assets/images/world-map.webp";
import { FlexGrid } from "../../../../common/grid/components/FlexGrid";

export const StyledBox = styled.section`
  && {
    width: 100%;
    background-image: url(${WorldMapImage});
    background-size: cover;
    background-color: #fd6520;
    background-position: center;
    padding: 0 100px;
  }

  @media (max-width: 900px) {
    && {
      padding: 0;
    }
  }
`;

export const Title = styled(Typography).attrs({ as: "h2" })`
  && {
    margin: 0;
    padding-top: 75px;
    width: 350px;

    font-family: Figtree, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: clamp(1.875rem, 2vw + 1rem, 2.5rem);
    line-height: 1.3;

    color: #ffffff;
  }

  @media (max-width: 900px) {
    && {
      width: min(100%, 600px);
      text-align: center;
    }
  }

  @media (max-width: 475px) {
    && {
      padding-top: 0;
      font-size: 30px;
      line-height: 40px;
    }
  }
`;

export const Text = styled(Typography).attrs({ as: "p" })`
  && {
    margin: 0;
    padding: 40px 0;

    font-family: Figtree, sans-serif;
    font-size: 1.12rem;
    font-style: normal;
    font-weight: 700;
    line-height: 31px;

    color: #ffffff;
  }

  @media (max-width: 900px) {
    && {
      max-width: 620px;
      text-align: center;
    }
  }

  @media (max-width: 475px) {
    && {
      font-size: 18px;
      line-height: 24px;
      padding: 24px 15px;
    }
  }
`;

export const Image = styled.img`
  && {
    width: 543px;
    max-width: 100%;
    height: auto;
    max-height: 570px;
    object-fit: contain;
    display: block;
  }

  @media (max-width: 1024px) {
    && {
      width: 354px;
      max-height: 367px;
    }
  }

  @media (max-width: 900px) {
    && {
      width: 543px;
      max-height: 570px;
      margin-bottom: 23px;
    }
  }

  @media (max-width: 475px) {
    && {
      width: 254px;
      max-height: 267px;
    }
  }
`;

export const TextGrid = styled(Grid)`
  && {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export const ImageGrid = styled(Grid)`
  && {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  @media (max-width: 900px) {
    && {
      justify-content: center;
    }
  }
`;

export const ButtonGroup = styled.div`
  && {
    width: 345px;
    max-width: 100%;
    z-index: 2;
    cursor: pointer;
  }

  @media (max-width: 475px) {
    && {
      width: 317px;
    }
  }
`;

export const DesktopVersion = styled(FlexGrid)`
  && {
    display: flex;
    max-width: 1400px;
    margin: 0 auto;

    padding-top: 25px;
    padding-bottom: 30px;
  }

  @media (max-width: 1280px) {
    && {
      padding: 30px;
    }
  }

  @media (max-width: 900px) {
    && {
      display: none;
    }
  }
`;

export const MobileVersion = styled(FlexGrid)`
  && {
    display: none;
    padding: 30px;
  }

  @media (max-width: 900px) {
    && {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
`;